import {
  Directive,
  Input,
  OnDestroy,
  OnInit,
  TemplateRef,
  ViewContainerRef,
  Output,
  EventEmitter,
} from '@angular/core';

@Directive({
  selector: '[appLazyRender]',
})
export class LazyRenderDirective implements OnInit, OnDestroy {
  @Input('appLazyRenderPlaceholder') placeholderTpl: TemplateRef<any> | null =
    null;
  @Input('appLazyRenderContent') contentTpl: TemplateRef<any> | null = null;

  @Output() becomeVisible = new EventEmitter<void>();

  private hasView = false;
  private observer: IntersectionObserver | null = null;

  constructor(private vcr: ViewContainerRef) {}

  ngOnInit(): void {
    if (this.placeholderTpl) {
      this.vcr.createEmbeddedView(this.placeholderTpl);
    }

    this.observer = new IntersectionObserver(
      (entries) => {
        const isVisible = entries[0]?.isIntersecting;
        if (isVisible && !this.hasView && this.contentTpl) {
          this.becomeVisible.emit();

          this.vcr.clear();
          this.vcr.createEmbeddedView(this.contentTpl);
          this.hasView = true;
          this.observer?.disconnect();
        }
      },
      {
        root: null,
        rootMargin: '50px',
        threshold: 0.1,
      }
    );

    const element = this.vcr.element.nativeElement;
    if (element) {
      this.observer.observe(element);
    }
  }

  ngOnDestroy(): void {
    this.observer?.disconnect();
  }
}
